import { useContext, useEffect } from 'react';
import { AxiosError } from 'axios';
import AppContext from '@context';
import { PER_PAGE } from '@constants';
import { ProposalGetPayloadInterface } from '@interface/proposals';
import { getProposals } from '@services/proposals';

const perPage = Number(PER_PAGE);

const useLoadProposals = (type: 'onload' | 'lazy' = 'lazy') => {
  const {
    state: { proposals },
    dispatch,
  } = useContext(AppContext);

  const fetchProposals = async ({ page = 1 }: ProposalGetPayloadInterface) => {
    dispatch({ type: 'proposals_loading' });

    try {
      const response = await getProposals({
        page,
      });

      dispatch({
        type: 'proposals_loading_success',
        payload: response,
      });
      dispatch({
        type: 'proposals_update_current_page',
        payload: {
          currentPage: response.meta.page,
        },
      });
    } catch (error) {
      const err = error as AxiosError['response'];

      dispatch({
        type: 'proposals_loading_error',
        payload: {
          statusCode: err?.status,
        },
      });
    }
  };

  const changePage = (newPage: number) => {
    const totalPages = Math.ceil(proposals.pending.meta.total / perPage);

    if (
      (proposals.pending.currentPage === 1 && newPage <= 1) ||
      newPage > totalPages
    ) {
      return;
    }

    fetchProposals({
      page: newPage,
    });
  };

  useEffect(() => {
    if (type === 'onload') {
      fetchProposals({
        page: 1,
      });
    }
  }, []);

  return { fetchProposals, changePage };
};

export default useLoadProposals;
